#import "@/components/common/LinkFragment.gql"

fragment CollectionsSliderFragment on collectionsSlider_Entry {
  typeHandle
  heading
  collections {
    ... on imageWithTitleBlock_Entry {
      image {
        url
        title
      }
      cta {
        ...LinkFragment
      }
    }
  }
}
